<template>
	<div id="buildingLeftTop">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">项目简介</span>
				</div>
			</div>
			<div class="head pl-4">
				<p>投入时间：<span>{{ surveyData.run_date }}</span></p>
				<p class="ml-5">墙体保温：<span>{{ surveyData.type }}</span></p>
			</div>
			<div class="building-box float-l ml-4">
				<div class="img" :style="{'background-image': 'url(' + surveyData.cover_url + ')'}"></div>
				<div class="d-flex jc-around flex-wrap ml-5" style="align-content: space-around">
					<div>
						<div class="item-box d-flex jc-around flex-column">
							<div>阴凉库面积</div>
							<p><span>{{ surveyData.cooling_region_area }}</span>m²</p>
						</div>
						<div class="item-box d-flex jc-around flex-column mt-3">
							<div>常温库面积</div>
							<p><span>{{ surveyData.normal_region_area }}</span>m²</p>
						</div>
					</div>
					<div class="ml-3">
						<div class="item-box d-flex jc-around flex-column">
							<div>阴凉库体积</div>
							<p><span>{{ surveyData.cooling_region_volume }}</span>m³</p>
						</div>
						<div class="item-box d-flex jc-around flex-column mt-3">
							<div>常温库体积</div>
							<p><span>{{ surveyData.normal_region_volume }}</span>m³</p>
						</div>
					</div>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				surveyData: {}
			};
		},
		components: {
			
		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.survey();
				},
			}
		},
		mounted() {
			this.survey()
		},
		methods: {
			async survey() {
				let dataObj = {
					building_id: this.building,
				}
				await this.$axios.get("/api/buildings/survey", {
					params: dataObj
				}).then(res => {
					this.surveyData = res.data.data
				})
			},
		},
	};
</script>

<style lang="scss">
	#buildingLeftTop {
		height: 3.5875rem;
		width: 6.45rem;
		.head{
			height: 0.8rem;
			font-size: 0.185rem;
			p{
				height: 0.8rem;
				line-height: 0.8rem;
				float: left;
			}
		}
		.building-box{
			// display: grid;
			// grid-template-columns: 40% 55%;
			.img{
				width: 1.8125rem;
				height: 1.8125rem;
				margin: 0 auto;
				background-size: cover;
				background-position: center center;
				border-radius: 10px;
			}
			.item-box{
				width: 1.6rem;
				height: 0.8375rem;
				background-image: linear-gradient(#072A4C, #063B6E);
				border: #1D9EBD solid 1px;
				text-align: center;
				div{
					color: #4293F4;
					font-size: 0.18rem;
				}
				p{
					color: #fff;
					span{
						font-size: 0.32rem
					}
				}
			}
		}
	}
</style>
